import { BoolDescription } from 'UI/constants/defaults';

export const formatSalesResponse = response => {
  const formattedData = (response?.data?.items ?? response?.data?.data ?? []).map(item => ({
    ...item,
    createdAt: item?.created_date,
    status: item?.status_name,
    candidateName: item?.candidate_name,
    transactionName: item?.transaction_name,
    dueDate: item?.due_date,
    onCollections: item?.on_collections && BoolDescription[item?.on_collections],
    openBillingText: item?.open_billing_text
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};
